// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__1JuGY","isDisabled":"Checkbox_isDisabled__2I_f_","checkbox":"Checkbox_checkbox__LH5H7","checkboxLabel":"Checkbox_checkboxLabel__2I0WP"};